import moment from "moment";
import { ITitle } from "../../models/interfaces/ITitle";
import { formatDate, formatDateHeure, regexDate, regexDateHeure } from "../../utils/helpers";

interface IProps {
  item: Record<string, unknown>;
  keyitem: string;
  columnsIndex: number[];
  titles: ITitle[];
  dataItemsStyle?: Record<string, unknown>;
}

const TableBodyItem: React.FC<IProps> = ({
  item,
  keyitem,
  titles,
  columnsIndex,
  dataItemsStyle,
}: IProps) => {

  const rows: any = Object.keys(item).map((k) => item[k]);

  const tableBodyItem = titles?.map((TitleElement, TitleElementIdx) => {
    const idx = Object.values(columnsIndex).filter(
      (idx) => idx === TitleElementIdx
    );

    const idxk = columnsIndex.indexOf(idx[0]);

    if (idxk > -1) {
      let value = rows[idxk];

      if (typeof value === "object") {
        value = "";
      }

      //Date Format Only
      if (regexDate.test(value)) {
        value = moment(value).format(formatDate);
      } 
      //Date Heure Format Only
      if (regexDateHeure.test(value)) {
        value = moment(value).format(formatDateHeure);
      } 

      if (dataItemsStyle) {
        const colStyleValue: any =
          Object.values(dataItemsStyle)[TitleElementIdx];
          if (colStyleValue === undefined) {
            return "colStyleValue non trouvé";
          }

        if (colStyleValue !== null && colStyleValue?.type) {
          value = (
            <colStyleValue.type
              key={TitleElementIdx}
              Item={value}
              {...colStyleValue.props}
            />
          );
        } else if (colStyleValue?.length > 0) {
          value = (
            <span
              key={TitleElementIdx}
              dangerouslySetInnerHTML={{
                __html: colStyleValue.replace("{Item}", value),
              }}
            />
          );
        }
      }
      if (TitleElementIdx === 0) {
        return (
          <th
            scope="row"
            className={TitleElement?.Class}
            key={"th_" + keyitem + "_" + TitleElementIdx}
            data-title={TitleElement?.Name}
          >
            {value !== 0 && value ? value : "_"}
          </th>
        );
      } else {
        return (
          <td
            className={TitleElement?.Class}
            key={"td_" +keyitem + "_" + TitleElementIdx}
            data-title={TitleElement?.Name}
          >
            {value !== 0 && value ? value : "_"}
          </td>
        );
      }
    } else {
      return null;
    }
  });

  return <>{tableBodyItem}</>;
};

export default TableBodyItem;
